import * as React from "react";
import {CoverChange, ICustomerPortalService, Types} from "@falcon/services";
import {lazyInject} from "@athena-portal/core";
import * as moment from "moment/moment";

interface IState {
    isLoading: boolean;
    replaceCarChanges: CoverChange[];
}

interface IProps {
    policyNumber: string;
}

export class UpcomingReplaceCarCoverBanner extends React.Component<IProps, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: any) {
        super(props);

        this.state = {
            isLoading: true,
            replaceCarChanges: []
        };
    }

    public async componentDidMount() {

        this.setState({isLoading: true});
        this.customerPortalService.getCoverChanges(this.props.policyNumber)
            .subscribe(
                (coverChanges: CoverChange[]) => {
                    this.setState({
                        replaceCarChanges: coverChanges.filter(cover => cover.type === "REPLACE_CAR"),
                        isLoading: false
                    })
                }
            )
    }
    public render(): React.ReactNode {

        if (!this.state.isLoading && this.state.replaceCarChanges && this.state.replaceCarChanges.length > 0) {
                return (
                    <div className="banner banner-info banner-info-multiple-paragraphs">
                        <p className="grid-col-2"><strong>Heads up - you've changed your vehicle</strong></p>
                        {this.generateCarChangeText(this.state.replaceCarChanges)}
                    </div>
                );
        } else {
            return <></>;
        }
    }

    public generateCarChangeText(coverChanges: CoverChange[]): JSX.Element {
        let textLines: string[] = [];

        coverChanges.forEach(coverChange => {
            const startDateText = this.convertDate(coverChange.startDate, "DD MMM YYYY");
            textLines.push(`The current cover for ${coverChange.previousValue} WILL END on ${startDateText}, 23:59`);
            textLines.push(`The new cover for ${coverChange.currentValue} WILL START on ${startDateText}, 00:00`);
        })

        const output = textLines.map((line: string, index) =>
            <li className="margin-bottom-8" key="key{index}">{line}</li>
        );
        return (<ul className="grid-col-2 m-0">{output}</ul>);
    }

    private convertDate = (inputDate: string, format: string) => {
        const valueAsMoment = moment.utc(inputDate, moment.ISO_8601);
        if (valueAsMoment.isValid()) {
            return (valueAsMoment.format(format))
        }
        return null;
    };
}



// WEBPACK FOOTER //
// ./src/components/banners/UpcomingReplaceCarCoverBanner.tsx